<div class="page collaborate">
	<div class="illustrated-item" id="entrada1">
		<div class="content">
			<p class="title">Colabora con nosotros</p>
			<p>Si quieres colaborar con nuestro proyecto de reinserción, puedes ingresar tu aportación económica a la cuenta:</p>
			<p class="bank-account">ES62 2038 1133 8762 0003 0005</p>
			<p>Gracias por tu generosidad.</p>
		</div>
	</div>
</div>
